import { motion, useScroll, useSpring } from "framer-motion";

export function ScrollProgress({ className = "", style = {} }) {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 200,
    damping: 50,
    restDelta: 0.001,
  });

  return (
    <motion.div
      className={className}
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        height: "3px",
        originX: 0,
        scaleX,
        background: "linear-gradient(90deg, #2ac48b 0%, #51e1a5 100%)",
        zIndex: 100,
        ...style,
      }}
    />
  );
}
